export const AGENDA_SOLUTION_CONSTANT = {
    // テーブル名
    TABLE: 'agenda_need',
    // csvファイル名
    CSV_FILENAME: '部門一覧'
  };
  